// extracted by mini-css-extract-plugin
export default {"header":"SectionHeader_header__ppu4V","decoration":"SectionHeader_decoration__t+D4k"};